import { Injectable } from '@angular/core';
import { CurrentUser } from './currentUser.service';

@Injectable()
export class AuthService {
  constructor(private currentUser: CurrentUser) {}

  public getAuthorizationHeader() {
    const token = this.currentUser.getJwtToken();
    return token ? 'Bearer ' + token : undefined;
  }
}
